import type { SavedAction, SavedActionVisibilityCondition } from "./actionTypes"

export interface SavedActionVisibilityState {
    taskRunning: boolean
    gitRepository: boolean
    gitWorkingChanges: boolean
    gitUnpushedCommits: boolean
}

export type SavedActionAvailability = "available" | "disabled" | "hidden"

function conditionMatches(condition: SavedActionVisibilityCondition, state: SavedActionVisibilityState): boolean {
    switch (condition) {
        case "task-idle":
            return !state.taskRunning
        case "task-running":
            return state.taskRunning
        case "git-repository":
            return state.gitRepository
        case "git-working-changes":
            return state.gitWorkingChanges
        case "git-unpushed-commits":
            return state.gitUnpushedCommits
    }
}

export function savedActionAvailability(action: SavedAction, state: SavedActionVisibilityState): SavedActionAvailability {
    if (!action.enabled) return "hidden"
    const { conditions, match } = action.visibility
    if (conditions.length === 0) return "available"
    const matches =
        match === "all"
            ? conditions.every((condition) => conditionMatches(condition, state))
            : conditions.some((condition) => conditionMatches(condition, state))
    if (matches) return "available"
    return action.visibility.onMismatch === "hide" ? "hidden" : "disabled"
}
